/**
 * Familles de zones proposées dans la petite fenêtre « Zones » des cartes.
 *
 * Douze types de lieu ne font pas douze cases à cocher: on les regroupe selon
 * ce qu'on y fait (franchir, stocker, se ravitailler, livrer, éviter). Les
 * couleurs reprennent celles que `ZoneLayer` utilise quand il peint par type;
 * les stations partagent celle des dépôts, la palette ne comptant que trois
 * teintes catégorielles distinguables.
 */
export const FAMILLES_FILTRE = [
  {
    cle: 'frontieres',
    label: 'Frontières',
    couleur: 'hsl(var(--cat-route))',
    types: ['border_post', 'customs_post', 'checkpoint'],
  },
  {
    cle: 'depots',
    label: 'Dépôts',
    couleur: 'hsl(var(--cat-hold))',
    types: ['fuel_depot', 'port'],
  },
  {
    cle: 'stations',
    label: 'Stations',
    couleur: 'hsl(var(--cat-hold))',
    types: ['station'],
  },
  {
    cle: 'livraison',
    label: 'Livraison',
    couleur: 'hsl(var(--cat-done))',
    types: ['delivery_site'],
  },
  {
    cle: 'risque',
    label: 'Zones à risque',
    couleur: 'hsl(var(--destructive))',
    types: ['risk_zone'],
  },
  // Tout le reste (villes, points de transit…): sans cette famille, ces lieux
  // ne se masqueraient jamais.
  { cle: 'autres', label: 'Autres', couleur: 'hsl(var(--muted-foreground))', types: [] },
];

const FAMILLE_PAR_TYPE = FAMILLES_FILTRE.reduce((table, famille) => {
  famille.types.forEach((type) => {
    table[type] = famille.cle;
  });
  return table;
}, {});

export const familleFiltre = (zone) => FAMILLE_PAR_TYPE[zone?.type] || 'autres';

/** Les zones des familles non masquées (`masquees`: clés de familles). */
export function filtrerZones(zones, masquees) {
  const liste = Array.isArray(zones) ? zones : [];
  if (!masquees || masquees.length === 0) return liste;
  const cachees = new Set(masquees);
  return liste.filter((zone) => !cachees.has(familleFiltre(zone)));
}

/** Nombre de zones par famille. */
export function compterParFamille(zones) {
  const compte = {};
  (Array.isArray(zones) ? zones : []).forEach((zone) => {
    const cle = familleFiltre(zone);
    compte[cle] = (compte[cle] || 0) + 1;
  });
  return compte;
}

/** Bascule une famille: la masque si elle est visible, la montre sinon. */
export const basculerFamille = (masquees, cle) =>
  masquees.includes(cle) ? masquees.filter((c) => c !== cle) : [...masquees, cle];

/** Zoom à partir duquel les noms de zones s'affichent sur la carte. */
export const ZOOM_ETIQUETTES_ZONES = 9;
